import create from "zustand";

const useShowWarningFlashStore = create((set: any) => ({
    showWarningFlash: false,
    setShowWarningFlash: (data: any) => set(() => ({ showWarningFlash: data })),
}));

export { useShowWarningFlashStore };
